/**
 * Tiny CSS-only spinner. No JS animation; lives off the existing
 * Tailwind `animate-spin` rule so it works in every browser we care
 * about. Default size is sane for inline use; bump up for full-pane
 * loading.
 */

export function Spinner({
  size = 14,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block animate-spin rounded-full border-2 border-cream-3 border-t-transparent ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}

/**
 * Centred block-level spinner with an optional label. Use inside a panel
 * when the data isn't here yet.
 */
export function LoadingBlock({
  label = 'Loading…',
  size = 22,
  hint,
}: {
  label?: string;
  size?: number;
  hint?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-10 text-sm text-cream-3">
      <Spinner size={size} />
      <span>{label}</span>
      {hint && <span className="text-xs text-cream-4">{hint}</span>}
    </div>
  );
}
